import httpService from '@/utils/request'
import { contextPath } from '@/config/'

export const getAccountPoolApi = (params) => {
  return httpService({
    url: contextPath + '/discovery/account/pool/info',
    method: 'get',
    params
  })
}

export const deleteAccountPoolApi = (accountPoolId) => {
  return httpService({
    url: contextPath + '/discovery/account/pool/item',
    method: 'delete',
    params: {
      accountPoolId
    }
  })
}

export const createAccountPoolApi = (data) => {
  return httpService({
    url: contextPath + '/discovery/account/pool/item',
    method: 'post',
    data
  })
}

export const modifyAccountPoolApi = (data) => {
  return httpService({
    url: contextPath + '/discovery/account/pool/item',
    method: 'put',
    data
  })
}

export const modifyAccountPoolStatusApi = (data) => {
  return httpService({
    url: contextPath + '/discovery/account/pool/item/changeStatus',
    method: 'put',
    // data,
    params: data
  })
}

// ---- 种子 ----
export const getSeedAccountPoolApi = (params) => {
  return httpService({
    url: contextPath + '/discovery/seed/pool/info',
    method: 'get',
    params
  })
}

export const deleteSeedAccountPollApi = (seedPoolId) => {
  return httpService({
    url: contextPath + '/discovery/seed/pool/item',
    method: 'delete',
    params: {
      seedPoolId
    }
  })
}

export const createSeedAccountPoolApi = (data) => {
  return httpService({
    url: contextPath + '/discovery/seed/pool/item',
    method: 'post',
    data
  })
}

export const modifySeedAccountPoolApi = (data) => {
  return httpService({
    url: contextPath + '/discovery/seed/pool/item',
    method: 'put',
    data
  })
}

export const modifySeedAccountPoolStatusApi = (data) => {
  return httpService({
    url: contextPath + '/discovery/seed/pool/item/changeStatus',
    method: 'put',
    params: data
  })
}

// 审核
export const verifySeedAccountPoolApi = (data) => {
  return httpService({
    url: contextPath + '/discovery/seed/pool/item/verify',
    method: 'put',
    params: data
  })
}
